import { HTMLAttributes } from 'react';
import { MarketActionCard, MarketRow, MarketAccessory } from '@market/react';
import QuestionMarkCircleIcon from '@square-icons/react/16/UI/circle-question-mark';
import styles from 'typescript/components/support_tile.module.scss';

export const SUPPORT_TILE_TEST_ID = 'support-tile';

interface SupportTileProps extends HTMLAttributes<HTMLElement> {
  label?: string;
  subtext?: string;
  onClick?: () => void;
}

const SupportTile = ({
  className,
  label,
  subtext,
  onClick,
}: SupportTileProps) => {
  return (
    <MarketActionCard
      data-testid={SUPPORT_TILE_TEST_ID}
      className={`${styles.supportTile} ${className}`}
      onClick={onClick}
      transient
    >
      <MarketRow transient>
        {label && <label slot="label">{label}</label>}
        {subtext && <p slot="subtext">{subtext}</p>}
        <MarketAccessory
          className={styles.questionIcon}
          slot="trailing-accessory"
        >
          <QuestionMarkCircleIcon />
        </MarketAccessory>
      </MarketRow>
    </MarketActionCard>
  );
};

export default SupportTile;
